import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

interface btnData {
  name: string;
  index: number;
}

@Component({
  selector: 'app-btn-group',
  templateUrl: './btn-group.component.html',
  styleUrls: ['./btn-group.component.less'],
})
export class BtnGroupComponent implements OnInit {
  @Input() list: Array<string>;
  @Input() active: number;
  @Output() btnclick: EventEmitter<any> = new EventEmitter<any>();
  isMoreText: boolean;
  hoverIndex: number;
  constructor() {}

  ngOnInit() {
    this.list.forEach(name => {
      if (!this.isMoreText && name.length > 3) {
        this.isMoreText = true;
      }
    });
  }

  btnClick(btnItem: btnData) {
    this.active = btnItem.index;
    this.btnclick.emit(btnItem);
  }

  mouseMove(index: number) {
    this.hoverIndex = index;
  }

  mouseLeave(index: number) {
    this.hoverIndex = -1;
  }
}
